export default {
  '--action-sheet-background': '#1e1e1e',
  '--action-sheet-title-color': '#aaa',
  '--action-sheet-action-item-color': '#fff'
};